"use client";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocale } from "@/lib/locale-context";

// Нижняя шторка (bottom-sheet) для мобильных модалок (даты, фильтр) — как на
// Солнышко: выезжает снизу, бэкдроп, ручка, прокручиваемый контент. Блокирует
// прокрутку страницы под собой.
export default function Bottomsheet({
  open, onClose, title, children, maxHeight = "88vh",
}: {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  maxHeight?: string;
}) {
  const { t } = useLocale();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [open, onClose]);

  if (!mounted || !open) return null;

  return createPortal(
    <div
      onClick={onClose}
      style={{ position: "fixed", inset: 0, zIndex: 9000, background: "rgba(13,20,42,0.5)", display: "flex", alignItems: "flex-end", backdropFilter: "blur(2px)" }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: "#fff", width: "100%", maxHeight, borderRadius: "20px 20px 0 0", display: "flex", flexDirection: "column", boxShadow: "0 -10px 40px rgba(13,20,42,0.25)", animation: "sheet-up 0.26s cubic-bezier(.2,.9,.3,1.02)" }}
      >
        <div style={{ padding: "12px 0 4px", display: "flex", justifyContent: "center", flexShrink: 0 }}>
          <span style={{ width: 40, height: 4, borderRadius: 2, background: "#D7DCE5" }} />
        </div>
        {title && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "4px 20px 12px", borderBottom: "1px solid #EDEDF0", flexShrink: 0 }}>
            <span style={{ fontSize: 18, fontWeight: 700, color: "#141D45" }}>{title}</span>
            <button onClick={onClose} aria-label={t("common.close")} style={{ width: 32, height: 32, borderRadius: "50%", border: "none", background: "#F5F5F7", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
          </div>
        )}
        <div style={{ overflowY: "auto", WebkitOverflowScrolling: "touch", flex: 1 }}>{children}</div>
      </div>
      <style>{`@keyframes sheet-up { from { transform: translateY(100%); } to { transform: none; } }`}</style>
    </div>,
    document.body,
  );
}
